import React from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import withRouter from "../../components/Common/withRouter";
import { DF_OT0040Context } from "./context";
import useGetCsrfToken from "../../Hooks/useGetCsrfToken";
import { useSelector } from "react-redux";
import GridBody from "./Grid/GridBody";

function DF_OT0040(props) {
  document.title = "Defender | Gestão de Entregas";
  const location = props.router.location;
  const [paramsOnFilter, setParamsOnFilter] = React.useState([]);
  const csrfToken = useGetCsrfToken(); 

  const { access_token, userProfile } = useSelector((state) => ({
      access_token: state.login.user?.access_token,
      userProfile: state.login.profile,
    }));

  return (
    <>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <DF_OT0040Context.Provider
        value={{
          paramsOnFilter,
          setParamsOnFilter,
          csrfToken,
          access_token,
          userProfile
        }}
      >
        <div className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader/>
            <GridBody />
          </Container>
        </div>
      </DF_OT0040Context.Provider>
    </>
  );
}

export default withRouter(DF_OT0040);
